/**
 * Asynchronously loads the component for HomePage
 */

import { lazyLoad } from 'utils/loadable';

export const SaleSpaceFilePage = lazyLoad(
  () => import('./index'),
  module => module.SaleSpaceFilePage
);
